export const questions = [
    "O design do Trilogic é atraente (interface, gráficos, etc.).",
    "Os textos, cores e fontes combinam e são consistentes.",
    "Aprender a utilizar o Trilogic foi fácil para mim.",
    "Eu acho que a maioria das pessoas aprenderiam a utilizar o Trilogic rapidamente.",
    "Eu considero que o Trilogic é fácil de utilizar.",
    "Quando olhei pela primeira vez o Trilogic, eu tive a impressão de que seria fácil para mim.",
    "O Trilogic é adequadamente desafiador para mim.",
    "O Trilogic oferece novos desafios (oferece novos obstáculos, situações ou variações) com um ritmo adequado.",
    "O Trilogic não se torna monótono nas suas tarefas (repetitivo ou com tarefas chatas).",
    "Me sinto satisfeito com as coisas que aprendi no Trilogic.",
    "Eu recomendaria o Trilogic para meus colegas.",
    "Eu me diverti com o Trilogic.",
    "Eu estava tão envolvido no Trilogic que eu perdi a noção do tempo.",
    "O Trilogic é um método de ensino adequado para a disciplina de lógica de programação.",
    "Eu prefiro aprender com o Trilogic do que de outra forma (outro método de ensino).",
    "O Trilogic contribuiu para a minha aprendizagem na disciplina de lógica de programação.",
]